import { Injectable } from '@angular/core';

/** Selectable local-impersonation options (dev only). */
export const DEBUG_ROLE_OPTIONS = [
  { value: '', label: 'Real role (MSAL)' },
  { value: 'Admin', label: 'Admin' },
  { value: 'RIPT-Worklist', label: 'RIPT-Worklist' },
  { value: 'RIPT Standalone', label: 'RIPT Standalone' },
  { value: '__inactive__', label: 'Inactive (deactivated)' },
] as const;

/**
 * Local-only role impersonation for development. Persists the chosen role in localStorage and derives
 * the `X-Debug-Role` / `X-Debug-Active` headers the API honors (Development environment only). Enabled
 * solely on localhost — a no-op everywhere else, so it can never affect a deployed build.
 */
@Injectable({ providedIn: 'root' })
export class DebugRoleService {
  private static readonly KEY = 'ript.debug.selection';

  readonly enabled =
    typeof window !== 'undefined' &&
    ['localhost', '127.0.0.1'].includes(window.location.hostname);

  selection(): string {
    return this.enabled ? localStorage.getItem(DebugRoleService.KEY) ?? '' : '';
  }

  set(selection: string): void {
    if (!this.enabled) return;
    if (selection) {
      localStorage.setItem(DebugRoleService.KEY, selection);
    } else {
      localStorage.removeItem(DebugRoleService.KEY);
    }
  }

  /** Debug headers to attach, or null when no impersonation is active. */
  headers(): { role: string; active: string } | null {
    if (!this.enabled) return null;
    const selection = this.selection();
    if (!selection) return null;
    if (selection === '__inactive__') return { role: 'RIPT Standalone', active: 'false' };
    return { role: selection, active: 'true' };
  }
}
